<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <div class="d-flex justify-content-between">
            <h6 class="element-header">Gelöschte Datensätze</h6>
          </div>

          <div class="element-box overflow-hidden">
            <div class="ps-4 mb-3">
              <div class="row" style="row-gap: 8px;">
                <div class="col-lg-3 col-md-4 col-sm-12" v-if="currentUserRole === 'ROLE_ADMIN'">
                  <router-link
                      class="link-primary-color"
                      :to="{name: 'deletedOfficeList'}">
                    Standorte
                  </router-link>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-12" v-if="currentUserRole === 'ROLE_ADMIN'">
                  <router-link
                      class="link-primary-color"
                      :to="{name: 'deletedClientList'}">
                    Kostenträger
                  </router-link>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-12" v-if="currentUserRole === 'ROLE_ADMIN'">
                  <router-link
                      class="link-primary-color"
                      :to="{name: 'deletedUnemployedList'}">
                    Kunden
                  </router-link>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-12"
                     v-if="
                     currentUserRole === 'ROLE_ADMIN' ||
                     currentUserRole === 'ROLE_PERSONAL' ||
                     currentUserRole === 'ROLE_HEAD_OF_HR'">
                  <router-link
                      class="link-primary-color"
                      :to="{name: 'deletedUserList'}">
                    Mitarbeiter
                  </router-link>
                </div>
              </div>
            </div>
            <div class="ps-4 pt-3" style="border-top: 1px solid #D8D8D8">
              <div class="row" style="row-gap: 8px;">
                <div class="col-lg-3 col-md-4 col-sm-12" v-if="currentUserRole === 'ROLE_ADMIN'">
                  <router-link
                      class="link-primary-color"
                      :to="{name: 'deletedCoursePrivateCoachingList'}">
                    Einzelcoachingmaßnahmen
                  </router-link>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-12" v-if="currentUserRole === 'ROLE_ADMIN'">
                  <router-link
                      class="link-primary-color"
                      :to="{name: 'deletedCourseGroupCoachingList'}">
                    Gruppenmaßnahmen
                  </router-link>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-12" v-if="currentUserRole === 'ROLE_ADMIN'">
                  <router-link
                      class="link-primary-color"
                      :to="{name: 'deletedCoursePrivateLearningCoachingList'}">
                    Private Weiterbildungen
                  </router-link>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <FormSidebar/>
    </div>
  </div>
</template>

<script setup>
import FormSidebar from '@/components/FormSidebar.vue';
import { piniaUserStore } from '@/store/piniaUserStore';
import { computed } from 'vue';

const piniaUserState   = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole  = piniaCurrentUser.value.roles[ 0 ];
</script>
<style scoped>
.element-box a.link-primary-color {
  display: inline-flex;
  align-items: center;
  padding: 6px 4px;
  color: #495057;
  font-weight: 500;
  transition: color 0.15s ease;
}

.element-box a.link-primary-color::before {
  content: '';
  width: 3px;
  height: 14px;
  margin-right: 10px;
  border-radius: 2px;
  background: var(--primary);
  flex-shrink: 0;
  transition: height 0.15s ease;
}

.element-box a.link-primary-color:hover {
  color: var(--primary);
  text-decoration: none;
}

.element-box a.link-primary-color:hover::before {
  height: 18px;
}
</style>
